// Simple tooltip without Popper.js - wrap input and tooltip in a container

export const createTooltipText = (textHtml: string, element: HTMLElement, className: string = '') => {
  const parent = element.parentElement
  if (!parent) return

  const tooltipHtml = document.createElement('span')
  tooltipHtml.className = className

  // Determine icon based on class (wrong or right)
  let iconHtml = ''
  if (className.includes('wrong')) {
    iconHtml = '<span class="mdi mdi-close" style="color: red; font-size: 18px;"></span>'
  } else if (className.includes('right')) {
    iconHtml = '<span class="mdi mdi-check" style="color: green; font-size: 18px;"></span>'
  }

  // Strip <p> tags from textHtml to prevent block display breaking the inline layout
  const strippedTextHtml = textHtml
    .replace(/<p[^>]*>/gi, '<span>')
    .replace(/<\/p>/gi, '</span>');

  // Set content with icon + text inline
  tooltipHtml.innerHTML = iconHtml + '<span>' + strippedTextHtml + '</span>';

  // Style tooltip as flex to keep icon and text on same line
  tooltipHtml.style.display = 'flex';
  tooltipHtml.style.alignItems = 'center';
  tooltipHtml.style.gap = '4px';
  tooltipHtml.style.marginTop = '-16px'; // Pull tooltip closer to input

  // Idempotent: may be called multiple times on the same input (content re-renders).
  // If already wrapped, just replace the old tooltip instead of nesting wrappers / duplicating.
  if (parent.dataset.tooltipWrapper === '1') {
    Array.from(parent.children).forEach((child) => {
      if (child !== element && (child as HTMLElement).classList.contains('textfield-question-answer')) {
        child.remove()
      }
    })
    parent.appendChild(tooltipHtml)
    return
  }

  // First time: wrap the input with a container that holds input + tooltip
  const wrapper = document.createElement('span');
  wrapper.dataset.tooltipWrapper = '1';
  wrapper.style.display = 'inline-block';
  wrapper.style.verticalAlign = 'top';
  wrapper.style.textAlign = 'left';

  parent.insertBefore(wrapper, element);
  wrapper.appendChild(element);
  wrapper.appendChild(tooltipHtml);
}


